/* eslint-disable react-hooks/exhaustive-deps */
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { GenericType } from "@/types";

import { useMemo } from "react";

type SelectPageItemProps = {
  placeholder?: string;
  labelBind: string;
  valueBind: string;
  value?: GenericType;
  onChange?: GenericType;
  className?: string;
  list: GenericType[];
  onBlur: () => void;
};

export const SelectInput = ({
  list,
  value,
  onChange,
  labelBind,
  valueBind,
  placeholder,
  className,
  onBlur,
}: SelectPageItemProps) => {
  const company_id = useMemo(() => {
    return list.map((item: GenericType) => {
      return { value: item[valueBind], label: item[labelBind] };
    });
  }, [list]);
  return (
    <Select
      value={value === undefined ? "" : "" + value}
      onValueChange={(prop) => {
        onChange(prop);
        onBlur();
      }}
    >
      <SelectTrigger className={cn("", className)}>
        <SelectValue placeholder={placeholder || "Select Dropdown"} />
      </SelectTrigger>
      <SelectContent>
        {company_id?.map((item: Record<string, string>, index: number) => {
          return (
            <SelectItem key={index} value={"" + item[valueBind]}>
              {item[labelBind]}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
